var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScanEnvelop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#155C8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9647 25.6662H9.87802C9.10614 25.6662 8.47461 25.0347 8.47461 24.2628V13.7372C8.47461 12.9653 9.10614 12.3338 9.87802 12.3338H28.1223C28.8942 12.3338 29.5257 12.9653 29.5257 13.7372V24.2628C29.5257 25.0347 28.8942 25.6662 28.1223 25.6662",
    fill: "#E8EFF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5249 22.1577V15.1406L22.999 18.6141L29.5249 22.1577Z",
    fill: "#B6CCDC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47461 15.1406V22.1577L15.0005 18.6141L8.47461 15.1406Z",
    fill: "#B6CCDC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1223 12.3338H9.87802C9.10614 12.3338 8.47461 12.9653 8.47461 13.7372V15.1406L17.8424 20.1227C18.5792 20.5087 19.4563 20.5087 20.158 20.1227L29.5257 15.1406V13.7372C29.5257 12.9653 28.8942 12.3338 28.1223 12.3338Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanEnvelop);
export default __webpack_public_path__ + "static/media/ScanEnvelop.7444d59f15e05625cbe49bccbea578be.svg";
export { ForwardRef as ReactComponent };